import { Component, Inject, OnInit } from '@angular/core';
import { Technology } from '../technology';
import { ActivatedRoute } from '@angular/router';
import { TechnologyService } from '../technology.service';
import { DatePipe } from '@angular/common';
import { NewTechnologyComment } from '../new-technology-comment';
import { EvaluationLog } from '../evaluation-log';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-technology-details',
  templateUrl: './technology-details.component.html',
  styleUrls: ['./technology-details.component.scss']
})
export class TechnologyDetailsComponent implements OnInit {

  technology!: Technology;

  /** Canonical order */
  state = [
    {color: '#8B8889', name: 'Hold'},
    {color: '#F9A825', name: 'Assess'},
    {color: '#1976D2', name: 'Trial'},
    {color: '#009640', name: 'Adopt'}
  ];

  sortedStates!: string[];

  collapsed = true;
  latestExperience!: EvaluationLog;

  evaluationLog: EvaluationLog[] = [];

  // Comment Input Fields
  comment!: string;
  commentBy!: string;
  commentProject!: string;
  commentVersion!: string;

  selectedState!: string;

  constructor(
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private technologyService: TechnologyService,
    @Inject(MAT_DIALOG_DATA) public data: Technology
  ) {}

  ngOnInit(): void {
    this.technology = this.data;
    this.evaluationLog = this.data['evaluation-logs']
      .filter(evaluationLog => evaluationLog.date != null)
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    this.latestExperience = this.evaluationLog[0];
    this.createSortedStates();
  }

  // temp disabled till we activate comments feature again
  addCommentToTechnology(): void {
    let dateValue = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (dateValue === null) {
      dateValue = '';
    }

    const newTechnologyComment: NewTechnologyComment = {
      comment: this.comment,
      date: dateValue,
      commentBy: this.commentBy,
      email: this.commentBy,
      technologyId: this.technology._id,
      project: this.commentProject,
      version: this.commentVersion
    };

    this.technologyService.addCommentToTechnology(newTechnologyComment).subscribe();
  }

  /**
   * FIXED: Order is ALWAYS Hold → Assess → Trial → Adopt
   */
  createSortedStates(): void {
    const ORDER = ['hold', 'assess', 'trial', 'adopt'];

    this.sortedStates = ORDER
      .filter(state =>
        state === this.latestExperience?.evaluation?.toLowerCase() ||
        state === this.latestExperience?.tendency?.toLowerCase() ||
        this.state.some(s => s.name.toLowerCase() === state)
      )
      .map(state =>
        state.charAt(0).toUpperCase() + state.slice(1)
      );
  }

  getStateDescription(state: string): string {
    if (state?.toLowerCase() === 'adopt') {
      return 'ADOPT represent technologies where there\'s no doubt that it\'s proven and mature for use.';
    } else if (state?.toLowerCase() === 'trial') {
      return 'TRIAL represent technologies that we think are ready for use, but they are not as completely proven as those in the Adopt ring.';
    } else if (state?.toLowerCase() === 'assess') {
      return 'ASSESS represent technologies that we think are interesting and worth keeping an eye on.';
    } else if (state?.toLowerCase() === 'hold') {
      return 'HOLD means don\'t start anything new with this technology.';
    } else {
      return 'UNKNOWN';
    }
  }
}
